import React from 'react';
import { endOfYear, format } from 'date-fns';
import { AppDataFormat } from '@bechtel/types';

import { Box, Text } from '@bechtel/gds';
import { formatBytes } from '@bechtel/client-common';
import { useLingui } from '@lingui/react';

export const FieldError = ({ msg }) => {
  const { i18n } = useLingui();
  return (
    <Box pt={{ sm: '400' }} pb={{ sm: '500' }}>
      <Text color="bechtel.red">{i18n._(msg)}</Text>
    </Box>
  );
};
export const DisplayFileDetails = ({ logo }) => {
  const { i18n } = useLingui();
  return (
    <Box flexDirection={{ sm: 'row' }}>
      <Text family="graphik" size="300" color="grey.1000" style={{ flexGrow: 1 }}>
        {i18n._(logo.fileName)}
      </Text>
      {logo.fileSize && (
        <Text family="graphik" size="300" color="grey.1000">
          {formatBytes(logo.fileSize)}
        </Text>
      )}
    </Box>
  );
};

export const TimeZoneSelectedItem = ({ item }: { item: any }) => {
  const { i18n } = useLingui();
  return (
    <Text family="graphik" size="400" color="grey.1000">
      {i18n._(item.displayText)}
    </Text>
  );
};
export const TimeZoneItem = ({ item }: { item: any }) => {
  const { i18n } = useLingui();
  return (
    <Text size="400" color="grey.1000">
      {i18n._(item.displayText)}
    </Text>
  );
};

export const DropdownSelectedItem = ({ item }: { item: any }) => {
  const { i18n } = useLingui();
  return (
    <Text family="graphik" size="400" color="grey.1000">
      {i18n._(item.name)}
    </Text>
  );
};
export const DropdownItem = ({ item }: { item: any }) => {
  const { i18n } = useLingui();
  return (
    <Text size="400" color="grey.1000">
      {i18n._(item.name)}
    </Text>
  );
};

export const FormattedItem = ({ value, description }) => {
  const { i18n } = useLingui();
  return (
    <Box flexDirection={{ sm: 'row' }}>
      <Text family="graphik" style={{ flexGrow: 1 }} size="400" color="grey.1000">
        {i18n._(value)}
      </Text>
      <Text family="graphik" size="400" color="grey.1000">
        {i18n._(description)}
      </Text>
    </Box>
  );
};

export const DateFormatSelectedItem = ({ item }: { item: AppDataFormat }) => {
  const result = endOfYear(new Date());
  const formattedDate = format(result, item.format);
  return (
    <Text size="400" color="grey.1000">
      {formattedDate}
    </Text>
  );
};
export const DateFormatItem = ({ item }: { item: AppDataFormat }) => {
  const result = endOfYear(new Date());
  const formattedDate = format(result, item.format);
  return <FormattedItem value={item.format} description={formattedDate} />;
};

export const TimeFormatSelectedItem = ({ item }: { item: AppDataFormat }) => {
  const result = new Date(2021, 12, 31, 13, 30, 0, 0);
  const formattedDate = format(result, item.format);
  return (
    <Text size="400" color="grey.1000">
      {formattedDate}
    </Text>
  );
};
export const TimeFormatItem = ({ item }: { item: AppDataFormat }) => {
  const result = new Date(2021, 12, 31, 13, 30, 0, 0);
  const formattedDate = format(result, item.format);
  return <FormattedItem value={formattedDate} description={item.description} />;
};
